import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col } from "reactstrap";
import CountUp from "react-countup";
import Widget from "../../../../components/Widget";

const BitbucketStatistics = () => {
  const [bitbucketStatisticsData, setBitbucketStatisticsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        "https://eadash.arabiansystems.com/api/Dashboard/BitbucketStatistics"
      )
      .then((response) => {
        setBitbucketStatisticsData(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const getColorState = (value) => {
    switch (value) {
      case "MERGED":
        return "bg-success";
      case "OPEN":
        return "bg-info";
      default:
        return "bg-danger";
    }
  };

  return (
    <>
      {bitbucketStatisticsData?.map((project) => {
        return (
          <Col lg={12} xs={12}>
            <Widget
              className="widget hotFix"
              bodyClass={"w-100 mt-lg"}
              fetchingData={loading}
              title={
                <h4>
                  {project?.name}
                  <span className="badge rounded-pill bg-light fw-normal pull-right text-dark mt-1">
                    <CountUp
                      start={0}
                      end={project?.count}
                      duration={2}
                      separator=","
                      enableScrollSpy
                    />
                  </span>
                </h4>
              }
            >
              {project?.pullResquests.map((item, id) => {
                return (
                  <div className="d-flex align-items-start mb-3" key={id}>
                    <i className={`la la-flag me-2 text-success`} />
                    <p className="mb-0 d-flex flex-column text-white">
                      {item?.title}{" "}
                      <span style={{ fontSize: "10px", color: "#D4EBF8" }}>
                        {item.author}
                      </span>
                    </p>
                    <span
                      className={`badge rounded-pill ${getColorState(
                        item?.state
                      )} fw-normal pull-right mt-1 mx-2`}
                    >
                      {item?.state}
                    </span>
                  </div>
                );
              })}
            </Widget>
          </Col>
        );
      })}
    </>
  );
};

export default BitbucketStatistics;
